/**
 * @file loading-provider.js
 * @description Provider do sistema de loading (CRA)
 */

import React, { useState } from "react"
import { LoadingContext } from "../contexts/loading-context.js"

/**
 * Provider do sistema de loading
 * @param {Object} props - Propriedades do componente
 * @param {React.ReactNode} props.children - Componentes filhos
 * @returns {React.ReactElement} Provider de loading
 */
export function LoadingProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false)
  const [loadingMessage, setLoadingMessage] = useState("")

  const showLoading = (message = "Carregando...") => {
    setLoadingMessage(message)
    setIsLoading(true)
  }

  const hideLoading = () => {
    setIsLoading(false)
    setLoadingMessage("")
  }

  const value = {
    isLoading,
    showLoading,
    hideLoading,
    loadingMessage,
  }

  return React.createElement(
    LoadingContext.Provider,
    { value },
    children
  )
}
